import React, { useState } from 'react';
import Header from '../components/Header';

const C = {
  alloggio: '#0071BA',
  alloggioDark: '#005a95',
  alloggioLight: '#e8f3fb',
  trasporto: '#EB1C24',
  attivita: '#FF5B00',
  servizi: '#009045',
  dark: '#0a1628',
  white: '#ffffff',
  text: '#1a1a2e',
  textLight: '#6b7280',
  border: '#e5e7eb',
  light: '#f5f7fa',
};

const TIPOLOGIE = [
  {
    id: 'hotel',
    emoji: '🏨',
    nome: 'Hotel',
    tagline: 'Comfort e servizi inclusi',
    descrizione: 'Dalla pensione all\'hotel 5 stelle: confronta stelle, colazione, piscina, spa e posizione. Ideale per chi vuole servizi garantiti senza pensieri.',
    perchi: ['Coppie', 'Business', 'Famiglie'],
    prezzo: '€€ – €€€€',
    cosa_confronti: [
      { ico: '⭐', txt: 'Categoria (1–5 stelle) e recensioni verificate' },
      { ico: '🍳', txt: 'Colazione inclusa, mezza pensione o solo pernottamento' },
      { ico: '📍', txt: 'Distanza dal centro, dalla spiaggia o dai punti d\'interesse' },
      { ico: '🏊', txt: 'Servizi: piscina, spa, palestra, parcheggio, Wi-Fi' },
      { ico: '🚪', txt: 'Tipologia camera: singola, doppia, suite, vista mare' },
      { ico: '💳', txt: 'Cancellazione gratuita e condizioni di pagamento' },
    ],
  },
  {
    id: 'appartamento',
    emoji: '🏠',
    nome: 'Appartamento',
    tagline: 'Casa tua ovunque nel mondo',
    descrizione: 'Cucina, lavatrice, spazio: un appartamento ti dà la libertà di vivere la destinazione come un abitante del posto. Perfetto per soggiorni lunghi o gruppi.',
    perchi: ['Famiglie', 'Gruppi', 'Soggiorni lunghi'],
    prezzo: '€ – €€€',
    cosa_confronti: [
      { ico: '🍽️', txt: 'Cucina attrezzata, piano cottura e forno' },
      { ico: '🛏️', txt: 'Numero di camere e posti letto totali' },
      { ico: '🧺', txt: 'Lavatrice, asciugatrice e dotazioni casa' },
      { ico: '📶', txt: 'Wi-Fi, smart TV e connessione inclusi' },
      { ico: '🏙️', txt: 'Quartiere, vicinanza ai mezzi pubblici e supermercati' },
      { ico: '🗝️', txt: 'Check-in autonomo, host disponibile, portineria' },
    ],
  },
  {
    id: 'bb',
    emoji: '☕',
    nome: 'B&B',
    tagline: 'Accoglienza autentica e locale',
    descrizione: 'Il bed & breakfast unisce il comfort di una camera privata alla colazione fatta in casa. Gestione familiare, atmosfera unica e spesso posizioni centrali a prezzi accessibili.',
    perchi: ['Coppie', 'Viaggiatori solitari', 'Weekend'],
    prezzo: '€ – €€',
    cosa_confronti: [
      { ico: '🥐', txt: 'Colazione inclusa: buffet, continentale o fatta in casa' },
      { ico: '🏡', txt: 'Gestione familiare o professionale' },
      { ico: '🛁', txt: 'Bagno privato o condiviso' },
      { ico: '📍', txt: 'Posizione: centro storico, campagna, mare' },
      { ico: '🗣️', txt: 'Lingue parlate dal proprietario' },
      { ico: '🌟', txt: 'Recensioni degli ospiti e punteggio ospitalità' },
    ],
  },
  {
    id: 'campeggio',
    emoji: '⛺',
    nome: 'Campeggio',
    tagline: 'A contatto con la natura',
    descrizione: 'Tenda, camper, bungalow o glamping: il campeggio offre un\'esperienza a contatto con la natura a prezzi contenuti. Confronta servizi, posizione e tipologia di sistemazione.',
    perchi: ['Avventurieri', 'Famiglie', 'Camperisti'],
    prezzo: '€ – €€',
    cosa_confronti: [
      { ico: '🏕️', txt: 'Piazzole per tenda, camper o roulotte' },
      { ico: '🛖', txt: 'Bungalow, lodge e glamping di lusso' },
      { ico: '🚿', txt: 'Servizi igienici: docce, bagni e allacci elettricità' },
      { ico: '🏊', txt: 'Piscina, area giochi, ristorante e animazione' },
      { ico: '🌲', txt: 'Posizione: mare, montagna, lago o parco naturale' },
      { ico: '🐾', txt: 'Ammissione animali domestici' },
    ],
  },
  {
    id: 'casavacanza',
    emoji: '🏡',
    nome: 'Casa Vacanza',
    tagline: 'Intera proprietà per te',
    descrizione: 'Villa, trullo, chalet: una casa vacanza offre privacy totale, spazi ampi e spesso dotazioni esclusive come piscina privata o giardino. Ideale per gruppi e famiglie numerose.',
    perchi: ['Famiglie numerose', 'Gruppi di amici', 'Vacanze lunghe'],
    prezzo: '€€ – €€€€',
    cosa_confronti: [
      { ico: '🏊', txt: 'Piscina privata, idromassaggio e zona relax' },
      { ico: '🌿', txt: 'Giardino, terrazza, barbecue e spazi esterni' },
      { ico: '🛏️', txt: 'Numero di camere, bagni e posti letto' },
      { ico: '🚗', txt: 'Posto auto, garage o parcheggio privato' },
      { ico: '📺', txt: 'Dotazioni complete: cucina, lavatrice, smart TV' },
      { ico: '📏', txt: 'Metratura e planimetria degli spazi interni' },
    ],
  },
  {
    id: 'ostello',
    emoji: '🎒',
    nome: 'Ostello',
    tagline: 'Social, centrale, economico',
    descrizione: 'Gli ostelli moderni non sono più solo dormitori. Confronta camere private e dormitori, bar, eventi sociali e posizione centrale. La scelta giusta per viaggiatori giovani e budget ridotto.',
    perchi: ['Viaggiatori solitari', 'Budget ridotto', 'Under 35'],
    prezzo: '€',
    cosa_confronti: [
      { ico: '🛏️', txt: 'Dormitorio (4–12 posti) o camera privata' },
      { ico: '🔒', txt: 'Armadietti con lucchetto per la sicurezza dei bagagli' },
      { ico: '🍻', txt: 'Bar interno, cucina comune ed eventi sociali' },
      { ico: '📍', txt: 'Posizione centrale e vicinanza ai mezzi pubblici' },
      { ico: '♻️', txt: 'Rating sostenibilità e politiche green' },
      { ico: '🌍', txt: 'Community internazionale e tour organizzati' },
    ],
  },
];

const STEPS = [
  {
    num: '1',
    titolo: 'Scegli le tipologie',
    testo: 'Seleziona solo le categorie che ti interessano. Se cerchi esclusivamente hotel, nascondi appartamenti e ostelli per una ricerca più rapida e mirata.',
    colore: C.alloggio,
  },
  {
    num: '2',
    titolo: 'Imposta i filtri',
    testo: 'Definisci date, numero di ospiti, prezzo massimo per notte e i servizi indispensabili (es. colazione inclusa, piscina, cancellazione gratuita).',
    colore: C.attivita,
  },
  {
    num: '3',
    titolo: 'Confronta affiancati',
    testo: 'Le opzioni selezionate appaiono in una vista comparativa: stesso prezzo, stessa posizione, stessi servizi — così scegliere diventa facile.',
    colore: C.servizi,
  },
  {
    num: '4',
    titolo: 'Salva nell\'esperienza',
    testo: 'L\'alloggio scelto si aggiunge automaticamente alla tua esperienza OCTA, insieme ai trasporti e alle attività che hai già pianificato.',
    colore: C.trasporto,
  },
];

export default function Alloggio() {
  const [attive, setAttive] = useState(new Set(TIPOLOGIE.map(t => t.id)));
  const [aperta, setAperta] = useState(null);

  const toggleTipo = (id) => {
    setAttive(prev => {
      const next = new Set(prev);
      if (next.has(id)) {
        if (next.size > 1) next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const selezionaTutte = () => setAttive(new Set(TIPOLOGIE.map(t => t.id)));

  const tipologieVisibili = TIPOLOGIE.filter(t => attive.has(t.id));

  return (
    <div style={{ minHeight: '100vh', backgroundColor: C.light, fontFamily: 'Roboto, sans-serif', color: C.text }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        a { text-decoration: none; }
        button { cursor: pointer; font-family: 'Roboto', sans-serif; }
        button:hover { opacity: 0.88; }
        .octa-hamburger { display: none; }
        @media (max-width: 1024px) {
          .octa-header { padding: 12px 24px !important; }
          .octa-hero { padding: 52px 32px 60px !important; }
          .octa-hero h1 { font-size: 38px !important; }
          .octa-section { padding: 52px 32px !important; }
          .octa-footer { padding: 24px 32px !important; }
        }
        @media (max-width: 640px) {
          .octa-hamburger { display: flex !important; align-items: center; }
          .octa-header { padding: 12px 16px !important; }
          .octa-nav-link { display: none !important; }
          .octa-hero { padding: 48px 20px 56px !important; }
          .octa-hero h1 { font-size: 34px !important; }
          .octa-section { padding: 48px 20px !important; }
          .octa-card-grid { grid-template-columns: 1fr !important; }
          .octa-steps-grid { grid-template-columns: 1fr !important; }
          .octa-tipo-pills { gap: 8px !important; }
          .octa-footer { padding: 24px 16px !important; flex-direction: column !important; align-items: flex-start !important; gap: 16px !important; }
          .octa-cta-btns { flex-direction: column !important; }
          .octa-cta-btns a { text-align: center !important; }
        }
        @media (max-width: 900px) {
          .octa-card-grid { grid-template-columns: 1fr 1fr !important; }
          .octa-steps-grid { grid-template-columns: 1fr 1fr !important; }
        }
        .tipo-pill { transition: all 0.15s ease; }
        .tipo-pill:hover { transform: translateY(-1px); }
        .card-alloggio { transition: box-shadow 0.15s ease; }
        .card-alloggio:hover { box-shadow: 0 8px 32px rgba(0,113,186,0.12); }
      `}</style>

      <Header bg={C.alloggio} />

      {/* HERO */}
      <section className="octa-hero" style={{ backgroundColor: C.alloggio, padding: '68px 60px 76px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', padding: '7px 18px', borderRadius: '50px', backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', marginBottom: '28px' }}>
            <img src="/images/alloggio_icona.png" alt="Alloggio" style={{ height: '18px' }} onError={e => { e.target.style.display = 'none'; }} />
            <span style={{ fontSize: '13px', fontWeight: 700, color: C.white, letterSpacing: '0.06em', textTransform: 'uppercase' }}>Segmento Alloggio</span>
          </div>
          <h1 style={{ fontSize: '50px', fontWeight: 900, color: C.white, lineHeight: 1.1, marginBottom: '20px' }}>
            Dove dormi,<br />
            <span style={{ color: C.white }}>scegli tu come.</span>
          </h1>
          <p style={{ fontSize: '17px', color: 'rgba(255,255,255,0.85)', lineHeight: 1.75, maxWidth: '600px', margin: '0 auto 36px' }}>
            Hotel, appartamento, B&B, campeggio, casa vacanza o ostello: confronta le principali tipologie di alloggio e tieni solo quelle che ti interessano davvero.
          </p>
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {TIPOLOGIE.map(t => (
              <span key={t.id} style={{ padding: '6px 14px', borderRadius: '50px', backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: C.white, fontSize: '13px', fontWeight: 600 }}>
                {t.emoji} {t.nome}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* BANNER COMING SOON */}
      <div style={{ backgroundColor: '#fffbeb', borderBottom: '1px solid #fde68a', padding: '13px 40px', textAlign: 'center' }}>
        <p style={{ fontSize: '14px', color: '#92400e', fontWeight: 600 }}>
          🚀 La ricerca comparativa in tempo reale è in arrivo — per ora condividi i tuoi alloggi preferiti e scopri quelli della community.
        </p>
      </div>

      {/* SEZIONE: SELETTORE TIPOLOGIE */}
      <section className="octa-section" style={{ padding: '64px 60px', backgroundColor: C.white }}>
        <div style={{ maxWidth: '1060px', margin: '0 auto' }}>
          <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: '16px', marginBottom: '36px' }}>
            <div>
              <p style={{ fontSize: '12px', fontWeight: 700, color: C.alloggio, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '10px' }}>Personalizza la ricerca</p>
              <h2 style={{ fontSize: '32px', fontWeight: 900, color: C.text, lineHeight: 1.2 }}>Seleziona le tipologie che ti interessano</h2>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '13px', color: C.textLight }}>{attive.size} di {TIPOLOGIE.length} attive</span>
              {attive.size < TIPOLOGIE.length && (
                <button onClick={selezionaTutte} style={{ padding: '7px 16px', borderRadius: '20px', border: `1px solid ${C.alloggio}`, backgroundColor: 'transparent', color: C.alloggio, fontSize: '13px', fontWeight: 600 }}>
                  Seleziona tutte
                </button>
              )}
            </div>
          </div>

          {/* PILL SELECTOR */}
          <div className="octa-tipo-pills" style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '48px' }}>
            {TIPOLOGIE.map(t => {
              const isOn = attive.has(t.id);
              return (
                <button
                  key={t.id}
                  className="tipo-pill"
                  onClick={() => toggleTipo(t.id)}
                  style={{
                    display: 'flex', alignItems: 'center', gap: '9px',
                    padding: '11px 22px', borderRadius: '50px',
                    border: `2px solid ${isOn ? C.alloggio : C.border}`,
                    backgroundColor: isOn ? C.alloggio : C.white,
                    color: isOn ? C.white : C.textLight,
                    fontSize: '14px', fontWeight: 700,
                    boxShadow: isOn ? `0 4px 16px rgba(0,113,186,0.25)` : 'none',
                  }}
                >
                  <span style={{ fontSize: '18px' }}>{t.emoji}</span>
                  {t.nome}
                  {isOn && <span style={{ fontSize: '12px', opacity: 0.75 }}>✓</span>}
                </button>
              );
            })}
          </div>

          {/* GRIGLIA CARD TIPOLOGIE */}
          {tipologieVisibili.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '48px', color: C.textLight }}>
              <p style={{ fontSize: '32px', marginBottom: '12px' }}>🏨</p>
              <p style={{ fontSize: '16px' }}>Seleziona almeno una tipologia per continuare.</p>
            </div>
          ) : (
            <div className="octa-card-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
              {tipologieVisibili.map(t => {
                const isAperta = aperta === t.id;
                return (
                  <div
                    key={t.id}
                    className="card-alloggio"
                    style={{ backgroundColor: C.white, borderRadius: '18px', border: `1px solid ${isAperta ? C.alloggio : C.border}`, borderTop: `3px solid ${C.alloggio}`, overflow: 'hidden', cursor: 'pointer' }}
                    onClick={() => setAperta(isAperta ? null : t.id)}
                  >
                    {/* Card header */}
                    <div style={{ padding: '24px 24px 20px', borderBottom: `1px solid ${C.border}` }}>
                      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', marginBottom: '12px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                          <span style={{ fontSize: '28px' }}>{t.emoji}</span>
                          <div>
                            <h3 style={{ fontSize: '17px', fontWeight: 800, color: C.text }}>{t.nome}</h3>
                            <p style={{ fontSize: '11px', color: C.alloggio, fontWeight: 700 }}>{t.tagline}</p>
                          </div>
                        </div>
                        <span style={{ fontSize: '18px', color: C.textLight, flexShrink: 0, marginTop: '2px' }}>{isAperta ? '▲' : '▼'}</span>
                      </div>
                      <p style={{ fontSize: '13px', color: C.textLight, lineHeight: 1.6 }}>{t.descrizione}</p>
                    </div>

                    {/* Metadati sempre visibili */}
                    <div style={{ padding: '14px 24px', display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
                      <div>
                        <p style={{ fontSize: '10px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '3px' }}>Prezzo medio</p>
                        <p style={{ fontSize: '14px', fontWeight: 800, color: C.alloggio }}>{t.prezzo}</p>
                      </div>
                      <div style={{ width: '1px', height: '28px', backgroundColor: C.border }} />
                      <div>
                        <p style={{ fontSize: '10px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '4px' }}>Ideale per</p>
                        <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                          {t.perchi.map(p => (
                            <span key={p} style={{ padding: '2px 8px', borderRadius: '10px', backgroundColor: C.alloggioLight, color: C.alloggio, fontSize: '11px', fontWeight: 600 }}>{p}</span>
                          ))}
                        </div>
                      </div>
                    </div>

                    {/* Dettagli espandibili */}
                    {isAperta && (
                      <div style={{ padding: '0 24px 20px', borderTop: `1px solid ${C.border}` }}>
                        <p style={{ fontSize: '11px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.08em', margin: '16px 0 12px' }}>Cosa puoi confrontare</p>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '9px' }}>
                          {t.cosa_confronti.map((v, i) => (
                            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                              <span style={{ fontSize: '15px', flexShrink: 0, marginTop: '1px' }}>{v.ico}</span>
                              <span style={{ fontSize: '13px', color: C.text, lineHeight: 1.5 }}>{v.txt}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {tipologieVisibili.length > 0 && (
            <p style={{ fontSize: '13px', color: C.textLight, textAlign: 'center', marginTop: '20px' }}>
              Clicca su una card per espandere i dettagli e vedere cosa puoi confrontare.
            </p>
          )}
        </div>
      </section>

      {/* SEZIONE: COME FUNZIONA LA RICERCA */}
      <section className="octa-section" style={{ padding: '72px 60px', backgroundColor: C.light }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '52px' }}>
            <p style={{ fontSize: '12px', fontWeight: 700, color: C.alloggio, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '12px' }}>Come funziona</p>
            <h2 style={{ fontSize: '34px', fontWeight: 900, color: C.text, marginBottom: '14px' }}>Trova l'alloggio perfetto in 4 passi</h2>
            <p style={{ fontSize: '16px', color: C.textLight, maxWidth: '520px', margin: '0 auto' }}>
              La ricerca alloggi di OCTA è modulare: parte dalle tipologie che vuoi e filtra fino a trovare esattamente quello che cerchi.
            </p>
          </div>
          <div className="octa-steps-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
            {STEPS.map((step, i) => (
              <div key={i} style={{ padding: '28px 22px', borderRadius: '16px', backgroundColor: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${step.colore}`, textAlign: 'center' }}>
                <div style={{ width: '44px', height: '44px', borderRadius: '50%', backgroundColor: step.colore, color: C.white, fontSize: '17px', fontWeight: 900, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>{step.num}</div>
                <h3 style={{ fontSize: '15px', fontWeight: 800, color: C.text, marginBottom: '10px' }}>{step.titolo}</h3>
                <p style={{ fontSize: '13px', color: C.textLight, lineHeight: 1.65 }}>{step.testo}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEZIONE: FILTRI AVANZATI */}
      <section className="octa-section" style={{ padding: '72px 60px', backgroundColor: C.alloggio }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '48px' }}>
            <p style={{ fontSize: '12px', fontWeight: 700, color: 'rgba(255,255,255,0.85)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '12px' }}>Filtri avanzati</p>
            <h2 style={{ fontSize: '32px', fontWeight: 900, color: C.white, marginBottom: '14px' }}>Cerca con precisione</h2>
            <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.8)', maxWidth: '500px', margin: '0 auto' }}>
              Oltre alla tipologia, potrai filtrare per tutti i parametri che contano davvero nella scelta di un alloggio.
            </p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '16px' }}>
            {[
              { ico: '💶', titolo: 'Budget per notte', desc: 'Imposta un massimale e vedi solo le opzioni nel tuo range.' },
              { ico: '📅', titolo: 'Date di soggiorno', desc: 'Check-in, check-out e numero di notti calcolate automaticamente.' },
              { ico: '👥', titolo: 'Numero di ospiti', desc: 'Adulti, bambini e neonati — la ricerca adatta i risultati.' },
              { ico: '📍', titolo: 'Distanza dal centro', desc: 'Filtra per raggio massimo dalla destinazione o da un punto specifico.' },
              { ico: '✅', titolo: 'Servizi obbligatori', desc: 'Colazione, piscina, parcheggio, Wi-Fi: solo chi li ha davvero.' },
              { ico: '🔄', titolo: 'Cancellazione gratuita', desc: 'Mostra solo strutture con rimborso completo entro una certa data.' },
            ].map((f, i) => (
              <div key={i} style={{ padding: '20px', borderRadius: '14px', backgroundColor: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.2)' }}>
                <span style={{ fontSize: '26px', display: 'block', marginBottom: '10px' }}>{f.ico}</span>
                <h4 style={{ fontSize: '14px', fontWeight: 700, color: C.white, marginBottom: '7px' }}>{f.titolo}</h4>
                <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.75)', lineHeight: 1.6 }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="octa-section" style={{ padding: '80px 60px', backgroundColor: C.white, textAlign: 'center' }}>
        <div style={{ maxWidth: '580px', margin: '0 auto' }}>
          <div style={{ width: '64px', height: '64px', borderRadius: '18px', backgroundColor: C.alloggioLight, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', fontSize: '30px' }}>🏨</div>
          <h2 style={{ fontSize: '32px', fontWeight: 900, color: C.text, marginBottom: '14px' }}>Hai trovato l'alloggio perfetto?<br />Condividilo con la community.</h2>
          <p style={{ fontSize: '16px', color: C.textLight, lineHeight: 1.7, marginBottom: '36px' }}>
            Aggiungi l'alloggio alla tua esperienza OCTA — insieme a trasporto, attività e servizi — e aiuta altri viaggiatori a scegliere meglio.
          </p>
          <div className="octa-cta-btns" style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/crea" style={{ padding: '15px 32px', borderRadius: '50px', backgroundColor: C.alloggio, color: C.white, fontSize: '15px', fontWeight: 700 }}>
              + Crea un'esperienza
            </a>
            <a href="/bacheca" style={{ padding: '15px 32px', borderRadius: '50px', border: `2px solid ${C.border}`, color: C.textLight, fontSize: '15px', fontWeight: 600 }}>
              Esplora la bacheca
            </a>
          </div>
        </div>
      </section>

      {/* ALTRI SEGMENTI */}
      <section style={{ padding: '40px 60px', backgroundColor: C.light, borderTop: `1px solid ${C.border}` }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          <p style={{ fontSize: '12px', fontWeight: 700, color: C.textLight, textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '18px' }}>Esplora gli altri segmenti</p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {[
              { label: 'Trasporto', color: C.trasporto, href: '/trasporto' },
              { label: 'Attività', color: C.attivita, href: '/attivita' },
              { label: 'Servizi', color: C.servizi, href: '/servizi' },
            ].map(seg => (
              <a key={seg.label} href={seg.href} style={{ padding: '10px 24px', borderRadius: '50px', border: `2px solid ${seg.color}`, color: seg.color, fontSize: '14px', fontWeight: 700, backgroundColor: C.white }}>
                {seg.label}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="octa-footer" style={{ padding: '32px 60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: C.alloggio, flexWrap: 'wrap', gap: '16px' }}>
        <img src="/images/logo_bianco.png" alt="OCTA" style={{ height: '32px', objectFit: 'contain' }} />
        <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>© 2025 OCTA — Online Complete Travel Agency</p>
        <div style={{ display: 'flex', gap: '8px' }}>
          {['trasporto', 'alloggio', 'attivita', 'servizi'].map(k => (
            <span key={k} style={{ width: '12px', height: '12px', borderRadius: '50%', display: 'inline-block', backgroundColor: C[k] }} />
          ))}
        </div>
      </footer>
    </div>
  );
}
